import { tEmployeeTypeModel } from './tEmployeeTypeModel';

export class tEmployeeModel {
    shopID: number;
    employeeID: string;
    etypeID: number;

    employeeJoinDate: Date;
    employeeChiName: string;
    employeeSurname: string;

    employeeFirstName: string;
    employeePhone: number;
    employeeGender: number;
    employeeDob: Date;

    employeeHKID: string;
    drCMP: string;
    drRegNo: string;

    employeeLeaveStart: Date;
    employeeLeaveEnd: Date;
    employeeRemark1: string;

    employeeRemark2: string;
    employeeRemark3: string;
    employeeRemark4: string;

    lastModifyDatetime: Date;
    lastModifyUserID: string;
    inActive : string;
}

export class tEmployeeWithTypeModel {
    shopID: number;
    employeeID: string;
    etypeID: number;

    employeeJoinDate: Date;
    employeeChiName: string;
    employeeSurname: string;

    employeeFirstName: string;
    employeePhone: number;
    employeeGender: number;
    employeeDob: Date;

    employeeHKID: string;
    drCMP: string;
    drRegNo: string;

    employeeLeaveStart: Date;
    employeeLeaveEnd: Date;
    employeeRemark1: string;

    employeeRemark2: string;
    employeeRemark3: string;
    employeeRemark4: string;

    lastModifyDatetime: Date;
    lastModifyUserID: string;
    inActive : string;

    etypeDesc: string;
    etypeDescEng: string;

}

export class EmployeeLeaveModel extends tEmployeeWithTypeModel {

    leaveDateList: EmployeeLeaveModel[];
}



export class tEmployeeReportModel extends tEmployeeWithTypeModel {

    settledConsultModel: settledConsultModel[];
    settledBillModel: settledBillModel[];
    settledPackageSaleModel: settledPackageSaleModel[];
}

export class tEmployeeReportSubModel {
    cltdConsultNumber: string;
    bpinvoicenumber: string;
    bpDateTime: Date;
    bpPaymentNumber: string;
    cltdItemID: string;
    cltdItemDesc: string;
    bpPackagePaymentMethodName: string;
    patientID: string;
    patientName: string;
    cltdFinalAmt: number;
}

export class settledConsultModel extends tEmployeeReportSubModel {

}

export class settledBillModel extends tEmployeeReportSubModel {

}

export class settledPackageSaleModel extends tEmployeeReportSubModel {

}


export class tEmployeeReportViewModel extends tEmployeeReportSubModel {
    shopID: number;
    employeeID: string;
    etypeID: number;

    employeeJoinDate: Date;
    employeeChiName: string;
    employeeSurname: string;

    employeeFirstName: string;
    employeePhone: number;
    employeeGender: number;
    employeeDob: Date;

    employeeHKID: string;
    drCMP: string;
    drRegNo: string;

    employeeLeaveStart: Date;
    employeeLeaveEnd: Date;
    employeeRemark1: string;

    employeeRemark2: string;
    employeeRemark3: string;
    employeeRemark4: string;

    lastModifyDatetime: Date;
    lastModifyUserID: string;

    etypeDesc: string;
    etypeDescEng: string;
}

export class tEmployeeModelV2 extends tEmployeeModel {
  employeeImagePath : string;
}


export class DefaultEmployeeTypeListModel {
    empolyeeList: tEmployeeModel[];
    defaultEmpolyee : tEmployeeModel;
}

export class DefaultEmployeeTypeListModelV2 extends DefaultEmployeeTypeListModel {
    isShowAll:string;
    isShowTransHis
  }
  